import { render, staticRenderFns } from "./ItemEdit_Packagings_List.vue?vue&type=template&id=295e7a48&"
import script from "./ItemEdit_Packagings_List.vue?vue&type=script&lang=js&"
export * from "./ItemEdit_Packagings_List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports